var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"date-progress"},[_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar",style:({ width: `${_vm.dateProgress}%` })})]),_c('div',{staticClass:"dot",style:({ left: `${_vm.dateProgress}%` })})])
}
var staticRenderFns = []

export { render, staticRenderFns }